module.exports = __webpack_public_path__ + "static/media/marketplace-product-img-5.eec89ddf.svg";